import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type"];
import { supportsLinearEasing } from '../../../utils/supports/linear-easing.mjs';
import { isGenerator } from '../../generators/utils/is-generator.mjs';

function applyGeneratorOptions(_ref) {
  var type = _ref.type,
      options = _objectWithoutProperties(_ref, _excluded);

  if (isGenerator(type) && supportsLinearEasing()) {
    return type.applyToOptions(options);
  } else {
    var _options$duration, _options$ease;

    (_options$duration = options.duration) !== null && _options$duration !== void 0 ? _options$duration : options.duration = 300;
    (_options$ease = options.ease) !== null && _options$ease !== void 0 ? _options$ease : options.ease = "easeOut";
  }

  return options;
}

export { applyGeneratorOptions };